import React from 'react';
import Lottie from 'react-lottie';
import useGetApi from '../../../../../hooks/use-get-api';
import { HeroLottieProps } from '../types';

const HeroLottie: React.FC<HeroLottieProps> = ({ className, id }) => {
  const lottieAnimationUrl =
    'https://assets.clear.in/cleartax/images/1752503096_af_animation.json';
  const { data: lottieAnimationData } = useGetApi(lottieAnimationUrl);

  if (!lottieAnimationData) {
    return null;
  }

  return (
    <div className={className} id={id}>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: lottieAnimationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
            clearCanvas: true,
            progressiveLoad: false,
            hideOnTransparent: true,
          },
        }}
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default HeroLottie;
